import { SearchQueryRequestType } from '../../common/types';
import { usePostFetch } from '../../utils/reactQuery';
import { pathToUrl } from '../../utils/router';
import { ApiRoutesEnum } from '../../utils/routes';

import { ClientType } from './Clients.types';

export type FetchClientsResponseType = {
  count: number;
  results: ClientType[];
};

export const useSearchClients = (payload: SearchQueryRequestType) =>
  usePostFetch<FetchClientsResponseType>(pathToUrl(ApiRoutesEnum.searchClients), payload);
